import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import TheDashboard from '@/components/TheDashboard/TheDashboard'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [{
    path: '/',
    component: TheDashboard,
    children: [{
      path: '/',
      name: 'home',
      meta: { title: 'Home', requiresAuth: true },
      component: () => import(/* webpackChunkName: "home" */ '@/views/index'),
    }, {
      path: '/articles',
      name: 'articles',
      meta: { title: 'Articles', requiresAuth: true },
      component: () => import(/* webpackChunkName: "articles" */ '@/views/articles'),
    }, {
      path: '/articles/:id',
      name: 'articles-id',
      meta: { title: 'Edit Article', requiresAuth: true },
      component: () => import(/* webpackChunkName: "articles" */ '@/views/articles/_id'),
    }, {
      path: '/brands',
      name: 'brands',
      meta: { title: 'Brands', requiresAuth: true },
      component: () => import(/* webpackChunkName: "brands" */ '@/views/brands'),
    }, {
      path: '/brands/:id',
      name: 'brands-id',
      meta: { title: 'Edit Brand', requiresAuth: true },
      component: () => import(/* webpackChunkName: "brands" */ '@/views/brands/_id'),
    }, {
      path: '/categories',
      name: 'categories',
      meta: { title: 'Categories', requiresAuth: true },
      component: () => import(/* webpackChunkName: "categories" */ '@/views/categories'),
    }, {
      path: '/categories/:id',
      name: 'categories-id',
      meta: { title: 'Edit Product Category', requiresAuth: true },
      component: () => import(/* webpackChunkName: "categories" */ '@/views/categories/_id'),
    }, {
      path: '/comments',
      name: 'comments',
      meta: { title: 'Comments', requiresAuth: true },
      component: () => import(/* webpackChunkName: "comments" */ '@/views/comments'),
    }, {
      path: '/distributors',
      name: 'distributors',
      meta: { title: 'Distributors', requiresAuth: true },
      component: () => import(/* webpackChunkName: "distributor" */ '@/views/distributors'),
    }, {
      path: '/distributors/:id',
      name: 'distributors-id',
      meta: { title: 'Edit Distributor', requiresAuth: true },
      component: () => import(/* webpackChunkName: "distributors" */ '@/views/distributors/_id'),
    }, {
      path: '/ingredients',
      name: 'ingredients',
      meta: { title: 'Ingredients', requiresAuth: true },
      component: () => import(/* webpackChunkName: "ingredients" */ '@/views/ingredients'),
    }, {
      path: '/ingredients/:id',
      name: 'ingredients-id',
      meta: { title: 'Edit Ingredient', requiresAuth: true },
      component: () => import(/* webpackChunkName: "ingredients" */ '@/views/ingredients/_id'),
    }, {
      path: '/inventories',
      name: 'inventories',
      meta: { title: 'Inventories', requiresAuth: true },
      component: () => import(/* webpackChunkName: "inventories" */ '@/views/inventories'),
    }, {
      path: '/newsletters',
      name: 'newsletters',
      meta: { title: 'Newsletters', requiresAuth: true },
      component: () => import(/* webpackChunkName: "newsletters" */ '@/views/newsletters'),
    }, {
      path: '/newsletters/:id',
      name: 'newsletters-id',
      meta: { title: 'Edit Newsletter', requiresAuth: true },
      component: () => import(/* webpackChunkName: "newsletters" */ '@/views/newsletters/_id'),
    }, {
      path: '/orders',
      name: 'orders',
      meta: { title: 'Orders', requiresAuth: true },
      component: () => import(/* webpackChunkName: "orders" */ '@/views/orders'),
    }, {
      path: '/orders/:id',
      name: 'orders-id',
      meta: { title: 'Order Details', requiresAuth: true },
      component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/_id'),
    }, {
      path: '/products',
      name: 'products',
      meta: { title: 'Products', requiresAuth: true },
      component: () => import(/* webpackChunkName: "products" */ '@/views/products'),
    }, {
      path: '/products/:id',
      name: 'products-id',
      meta: { title: 'Edit Product', requiresAuth: true },
      component: () => import(/* webpackChunkName: "products" */ '@/views/products/_id'),
    }, {
      path: '/recipes',
      name: 'recipes',
      meta: { title: 'Recipes', requiresAuth: true },
      component: () => import(/* webpackChunkName: "recipes" */ '@/views/recipes'),
    }, {
      path: '/recipes/:id',
      name: 'recipes-id',
      meta: { title: 'Edit Recipe', requiresAuth: true },
      component: () => import(/* webpackChunkName: "recipes" */ '@/views/recipes/_id'),
    }, {
      path: '/requests',
      name: 'requests',
      meta: { title: 'Requests', requiresAuth: true },
      component: () => import(/* webpackChunkName: "requests" */ '@/views/requests'),
    }, {
      path: '/snaps',
      name: 'snaps',
      meta: { title: 'Snaps', requiresAuth: true },
      component: () => import(/* webpackChunkName: "snaps" */ '@/views/snaps'),
    }, {
      path: '/subscribers',
      name: 'subscribers',
      meta: { title: 'Mailing List', requiresAuth: true },
      component: () => import(/* webpackChunkName: "subscribers" */ '@/views/subscribers'),
    }, {
      path: '/users',
      name: 'users',
      meta: { title: 'Users', requiresAuth: true },
      component: () => import(/* webpackChunkName: "users" */ '@/views/users'),
    }, {
      path: '/users/:id',
      name: 'users-id',
      meta: { title: 'User Details', requiresAuth: true },
      component: () => import(/* webpackChunkName: "users" */ '@/views/users/_id'),
    }],
  }, {
    path: '/login',
    name: 'login',
    meta: { title: 'Account Login' },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
  }, {
    path: '/404',
    alias: '*',
    name: '404',
    meta: { title: 'Page Not Found' },
    component: () => import(/* webpackChunkName: "404" */ '@/views/404'),
  }]
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = `${ to.meta.title } · Nyonya Cooking`
  } else {
    document.title = 'Nyonya Cooking'
  }
  if (to.matched.some(route => route.meta.requiresAuth)) {
    try {
      await store.dispatch('refresh')
    } catch(err) {
      return next({ name: 'login' })
    }
    if (store.getters.isAuth) {
      return next()
    } else {
      return next({ name: 'login' })
    }
  }
  return next()
})

export default router
